import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import type { OzBaseDialogBoxButtonData } from '@@/library/v4/components/OzBaseDialogBox.vue'
import OzBaseDialogBox, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzBaseDialogBox.vue'
import OzInput from '@@/library/v4/components/OzInput.vue'
import OzLabelInput from '@@/library/v4/components/OzLabelInput.vue'
import { computed, ref } from 'vue'
import type { StyleValue } from 'vue/types/jsx'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzInputDialogBox',
  props: {
    title: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    iconSrc: { default: null },
    iconAlt: { default: null },
    subtitle: { default: undefined },
    label: { default: '' },
    value: { default: '' },
    placeholder: { default: '' },
    type: { default: 'text' },
    ariaLabel: { default: '' },
    maxLength: { default: null },
    submitButtonText: { default: undefined },
    cancelButtonText: { default: undefined },
    submitButtonDisabled: { type: Boolean, default: false },
    forceFullWidthButtons: { type: Boolean, default: false },
    valid: { type: Boolean, default: true },
    validationMessage: { default: '' },
    contentContainerStyle: { default: undefined }
  },
  emits: ["update", "submit", "cancel"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'update', value: string): void
  (event: 'submit', value: string): void
  (event: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, darkMode: true | false | 'auto', iconSrc: string | null, iconAlt: string | null, subtitle: string, label: string, value: string, placeholder: string, type: string, ariaLabel: string, maxLength: number | null, submitButtonText: string, cancelButtonText: string, submitButtonDisabled: boolean, forceFullWidthButtons: boolean, valid: boolean, validationMessage: string, contentContainerStyle: StyleValue }





const localValue = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('update', value)
  },
})

const buttons = computed<OzBaseDialogBoxButtonData[]>(() => {
  const buttonList = [
    {
      text: props.cancelButtonText || __('Cancel'),
      emit: 'cancel',
      colorScheme: OzContainedButtonColorScheme.Secondary,
      testId: 'cancelButton',
    },
    {
      text: props.submitButtonText || __('Submit'),
      emit: 'submit',
      colorScheme: OzContainedButtonColorScheme.Primary,
      disabled: props.submitButtonDisabled,
      testId: 'submitButton',
    },
  ]

  return props.forceFullWidthButtons ? buttonList.reverse() : buttonList
})

const dialogInput = ref<InstanceType<typeof OzInput> | null>(null)

const focus = () => {
  dialogInput.value?.focusInput()
}

const submit = () => {
  emit('submit', localValue.value)
}

const cancel = () => {
  emit('cancel')
}

expose({
  focus,
})

return { __sfc: true,props, emit, localValue, buttons, dialogInput, focus, submit, cancel, OzBaseDialogBox, OzInput, OzLabelInput }
}

})